import { getCachedAuthContext } from "~/components/auth";

const ORG_ID_REGEXP = new RegExp(
  `^/organisation/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}`,
);

const PATHS_WITHOUT_ORG_ID = [
  "/shared/cultureReport",
  "/auth/callback",
  "/auth/signout-callback",
  "/join",
  // Integration providers return here; it picks its organisation itself.
  "/integrations/callback",
];

const prependOrgIdToPath = (orgId: string | null, path = "") => {
  if (!orgId) return path;
  const barePath = path.replace(ORG_ID_REGEXP, "");
  if (PATHS_WITHOUT_ORG_ID.includes(barePath)) return barePath;
  const pathWithOrgId = `/organisation/${orgId}${barePath}`;
  return pathWithOrgId.replace(/\/$/, "");
};

export const useEnsureOrgIdPath = (path?: string) => {
  return useEnsureOrgIdPathFn()(path);
};

export const useEnsureOrgIdPathFn = () => {
  return (path?: string) => {
    const orgId = getCachedAuthContext()?.orgId;
    if (path && !path.startsWith("/")) {
      return "";
    }
    if (!orgId) return path || "";
    return prependOrgIdToPath(orgId, path);
  };
};

// deprecated - use named export
export default useEnsureOrgIdPath;
